import * as ActionTypes from "../action-types";

const user_DEFAULT_STATE = {};

export const user = (state = user_DEFAULT_STATE, action) => {
  let newState = JSON.parse(JSON.stringify(state));

  if (!action) return newState;

  switch (action.type) {
    case ActionTypes.SSO_USER_SIGN_IN: {
      const user = action.user;
      newState = user;
      return newState;
    }
    case ActionTypes.SSO_USER_SIGN_OUT: {
      return user_DEFAULT_STATE;
    }
    case ActionTypes.SSO_USER_SIGN_UP: {
      const email = action.email;
      newState = email;
      return newState;
    }
    case ActionTypes.SET_USER_EMAIL_DATA: {
      const email = action.email;
      newState.email = email;
      return newState;
    }
    case ActionTypes.SSO_USER_RESET_PASSWORD_REQUEST: {
      const link = action.link;
      newState.link = link;
      return newState;
    }
    case ActionTypes.SSO_SET_INDIVIDUAL_DATA: {
      const user = action.user;
      newState = user;
      return newState;
    }
    default: {
      return newState;
    }
  }
};
